'use client';

import { FC, useMemo } from 'react';
import { ReadOnlyListing } from 'hotdesk_typescript';
import { MyListing } from '@/hotdesk-ui/services/listing.service';
import { convertToCartesian, getListingsBounds } from '@/hotdesk-ui/helpers/location.helper';
import MapContainerTile from '../google-map/MapContainerTile';
import NoWorkspace from '../no-workspace/NoWorkspace';
import styles from './ExploreMap.module.scss';
export interface ExploreMapProps {
  /** Pins to render on the map. Typically the accumulated set across pans. */
  items: ReadOnlyListing[];
  /**
   * Stable seed for the initial map centroid. Defaults to `items` if omitted.
   * Pass the current search results so the centroid doesn't drift as the
   * accumulator grows.
   */
  centroidSeed?: ReadOnlyListing[];
  isWorkspaceMode?: boolean;
  onCanvasChanged?: (center: {
    lat: number;
    lng: number;
  }, radiusKm: number, zoom: number) => void;
  onToggleExpandMap?: (expand: boolean) => void;
}
const ExploreMap: FC<ExploreMapProps> = ({
  items,
  centroidSeed,
  isWorkspaceMode = false,
  onCanvasChanged,
  onToggleExpandMap
}) => {
  const mapType = isWorkspaceMode ? 'workspaces' : 'listings';
  const seed = centroidSeed && centroidSeed.length > 0 ? centroidSeed : items;
  const cart = useMemo(() => convertToCartesian(seed as unknown as MyListing[], mapType), [seed, mapType]);
  // Same seed as the centroid: frame the current search's pins, not every
  // pin accumulated while panning.
  const fitBounds = useMemo(() => getListingsBounds(seed as unknown as MyListing[], mapType), [seed, mapType]);
  const showEmptyState = items.length === 0 && seed.length === 0;
  if (showEmptyState) {
    return <div className={styles.empty}>
                <NoWorkspace />
            </div>;
  }
  return <div className={styles.wrap} data-sentry-component="ExploreMap" data-sentry-source-file="ExploreMap.tsx">
            <div className={styles.mapBox}>
                <MapContainerTile userListing={isWorkspaceMode ? undefined : items as unknown as MyListing[]} userWorkspace={isWorkspaceMode ? items as unknown as ReadOnlyListing[] : undefined} type={isWorkspaceMode ? 'workspace' : 'listing'} lat={cart.lat} lng={cart.lng} fitBounds={fitBounds} transformArray={cart.transformArray} expandMap={true} drawerStatus="" onCanvasChanged={onCanvasChanged} onClickExpandMap={onToggleExpandMap} data-sentry-element="MapContainerTile" data-sentry-source-file="ExploreMap.tsx" />
            </div>
        </div>;
};
export default ExploreMap;